import React, { useRef, useState } from "react";
import { MenuItem, MenuList } from "@mui/material";
import { CustomButton } from "../../../buttons";
import styles from "./RevValSelector.module.css";
import { IconComponent, icon } from "../../../icon-component";
import DropDown from "../../../drop-down/DropDown";
import { isNonEmptyArray } from "../../../../utils";
import { translate } from "../../../../providers";
import { InfiniteList2 } from "../../../infinite-list";

const RevValSelector = ({ items, onChange, size = "sm", value, readOnly, reviewersRequest, selectedUsers = [] }) => {
	const [open, setOpen] = useState(false);
	const [openReviewers, setOpenReviewers] = useState(false);
	const [hasManyUsers, setHasManyUsers] = useState(false);
	const [activeSearch, setActiveSearch] = useState("");
	const anchorRef = useRef(null);
	const reviewersAnchorRef = useRef(null);
	const reviewersContentRef = useRef(null);
	const handleOpen = () => {
		if (readOnly) {
			return;
		}
		setOpen(true);
	};
	const handleOpenReviewers = () => {
		setOpenReviewers(true);
	};
	const handleCloseReviewers = () => {
		setOpenReviewers(false);
	};
	const handleClose = (e) => {
		if (reviewersContentRef.current && reviewersContentRef.current.contains(e?.target)) {
			return;
		}
		setOpen(false);
		handleCloseReviewers();
	};
	const handleSelectReviewer = (e, selection) => {
		e.stopPropagation();
		onChange({ id: "othersReviewByUser", user: selection });
	};
	const handleSelect = (selection) => {
		if (selection.hasReviewers) {
			handleOpenReviewers();
		} else {
			onChange(selection);
			handleClose();
		}
	};
	const handleResponse = (data, search) => {
		if (!search) {
			setHasManyUsers(data.totalElements > 15);
		}
		setActiveSearch(search);
	};
	const highlightPrefix = (text) => {
		if (!text.startsWith(activeSearch)) {
			return <>{text}</>;
		}
		return (
			<>
				<strong>{activeSearch}</strong>
				{text.slice(activeSearch.length)}
			</>
		);
	};
	const rowRenderer = (item) => {
		const isSelected = selectedUsers.includes(item?.id);
		return (
			<MenuItem
				className={styles.userReviewerRole}
				data-selected={isSelected}
				disabled={isSelected}
				onClick={(e) => handleSelectReviewer(e, item)}
			>
				<IconComponent
					color={isSelected ? "var(--blue-500)" : "var(--grey-700)"}
					icon={icon.faCheck}
					size="xs"
				/>
				<span className={styles.reviewerName}>{highlightPrefix(item?.displayName)}</span>
			</MenuItem>
		);
	};
	return (
		<>
			<CustomButton
				ref={anchorRef}
				className={styles.button}
				color="secondary"
				data-size={size}
				data-testid="position.partner.btn"
				endIcon={icon.faChevronDown}
				variant="outlined"
				onClick={handleOpen}
			>
				{value?.name}
			</CustomButton>
			<DropDown ref={anchorRef} open={open} onClose={handleClose}>
				<MenuList className={styles.dropDown__container}>
					{isNonEmptyArray(items) &&
						items
							.filter((item) => item?.display || value?.id === item?.id)
							.map((item) => {
								const isSelected =
									value?.id === item?.id ||
									(item?.id === "othersReviewByUser" && value?.name && !value?.helperText);
								return (
									<MenuItem
										key={item?.id || item}
										ref={item?.hasReviewers && reviewersAnchorRef}
										className={styles.menuItem}
										data-selected={value?.id === item?.id}
										disabled={value?.id === item?.id && value?.id !== "othersReviewByUser"}
										onClick={() => handleSelect(item)}
									>
										<div className={styles.statusDropDownListItem__container}>
											<IconComponent
												color={isSelected ? "var(--blue-500)" : "var(--grey-700)"}
												icon={item?.isReviewer ? icon.faCheck : icon.faCheckDouble}
												size="2xs"
											/>
											<div>
												<div
													className={styles.statusDropDownListItem__title}
													data-selected={
														value?.id === item?.id ||
														(item?.id === "othersReviewByUser" &&
															value?.name &&
															!value?.helperText)
													}
												>
													{item?.name}
												</div>
												<div className={styles.statusDropDownListItem__helper}>
													{translate(
														item?.isReviewer
															? "common:filter.status.review-positions"
															: "common:filter.status.validation-positions"
													)}
												</div>
											</div>
											{item?.hasReviewers && (
												<IconComponent
													color={isSelected ? "var(--blue-500)" : "var(--grey-700)"}
													icon={icon.faChevronRight}
													size="2xs"
												/>
											)}
										</div>
									</MenuItem>
								);
							})}
				</MenuList>
			</DropDown>
			<DropDown
				ref={reviewersAnchorRef}
				open={openReviewers}
				position="right-start"
				onClose={handleCloseReviewers}
			>
				<div ref={reviewersContentRef}>
					<InfiniteList2
						callOnResponse={handleResponse}
						className={styles.infiniteListContainer}
						hasSearch={hasManyUsers}
						request={reviewersRequest}
						rowRenderer={rowRenderer}
					/>
				</div>
			</DropDown>
		</>
	);
};

export default RevValSelector;
